export default "__VITE_ASSET__D4au0UCg__"